export const ARBITRAGE_MODES = [
  { value: "arbitrage", label: "Arbitrage" },
  { value: "cs", label: "Commissaires sportifs" },
  { value: "quiz", label: "Quiz" },
];

export const ARBITRAGE_SECTIONS = [
  {
    id: "role-arbitre",
    mode: "arbitrage",
    badge: "Arbitre",
    title: "Rôle de l’arbitre",
    description:
      "L’arbitre garantit le bon déroulement du combat, la sécurité des combattants et l’application des règles.",
    image:
      "https://res.cloudinary.com/dy5kblr32/image/upload/v1720731205/images/arbitrage/arbitrage_judo_01_zlmwhp.jpg",
    bullets: [
      "Assurer la sécurité des combattants.",
      "Faire respecter les règles du judo.",
      "Attribuer les points et les pénalités.",
      "Déterminer le vainqueur du combat.",
    ],
  },
  {
    id: "commandes-arbitre",
    mode: "arbitrage",
    badge: "Commandes",
    title: "Les principales commandes de l’arbitre",
    image:
      "https://res.cloudinary.com/dy5kblr32/image/upload/v1720757031/images/arbitrage/arbitrage_judo_06_h2yqp4.jpg",
    rules: [
      {
        id: "hajime",
        title: "Hajime : début du combat",
        paragraphs: [
          "Hajime est le terme japonais utilisé pour commencer ou reprendre le combat après une pause.",
        ],
      },
      {
        id: "matte",
        title: "Matte : arrêt temporaire du combat",
        paragraphs: [
          "Matte signifie que l’arbitre interrompt momentanément le combat.",
        ],
      },
      {
        id: "sore-made",
        title: "Sore-made : fin du combat",
        paragraphs: [
          "Sore-made indique la fin du combat. L’arbitre désigne ensuite le vainqueur.",
        ],
      },
      {
        id: "osaekomi",
        title: "Osaekomi : début d’une immobilisation",
        paragraphs: [
          "Osaekomi signifie qu’une immobilisation est effective et que le chronomètre d’immobilisation démarre.",
        ],
      },
      {
        id: "toketa",
        title: "Toketa : fin d’une immobilisation",
        paragraphs: [
          "Toketa indique que l’immobilisation n’est plus valable et que le chronomètre d’immobilisation s’arrête.",
        ],
      },
    ],
  },
  {
    id: "points-penalites",
    mode: "arbitrage",
    badge: "Score",
    title: "Points, avantages et pénalités",
    image:
      "https://res.cloudinary.com/dy5kblr32/image/upload/v1720731797/images/arbitrage/arbitrage_judo_04_o2hiap.webp",
    rules: [
      {
        id: "ippon",
        title: "Ippon",
        paragraphs: [
          "Ippon est le score le plus élevé. Il donne la victoire immédiate. Il peut être obtenu par une projection contrôlée sur le dos avec force et vitesse, par une immobilisation de 20 secondes, par une clé de bras ou par un étranglement.",
        ],
      },
      {
        id: "waza-ari",
        title: "Waza-ari",
        paragraphs: [
          "Waza-ari est accordé lorsqu’une action est proche de l’ippon sans réunir toutes les conditions. Il est aussi donné pour une immobilisation de 10 à 19 secondes.",
        ],
      },
      {
        id: "yuko",
        title: "Yuko",
        paragraphs: [
          "Le yuko correspond à un avantage. Il peut notamment être donné pour certaines actions ou immobilisations courtes selon les règlements appliqués.",
        ],
      },
      {
        id: "shido-hansoku",
        title: "Shido et Hansoku-make",
        paragraphs: [
          "Shido est une pénalité mineure. Trois shido entraînent Hansoku-make, c’est-à-dire la disqualification du combat.",
        ],
      },
    ],
  },
  {
    id: "regles-2025",
    mode: "arbitrage",
    badge: "Évolution",
    title: "Nouvelles règles d’arbitrage 2025",
    image:
      "https://medias.franceantilles.fr/api/v1/images/view/63aa011d9ba20202db1fd078/width_1000/image.jpg",
    bullets: [
      "Retour du yuko, notamment en ne-waza après cinq secondes d’immobilisation selon le règlement appliqué.",
      "Utilisation de la tête à nouveau autorisée dans certains cas, avec restriction chez les cadets.",
      "Certaines saisies sous la ceinture peuvent être autorisées si elles ne sont pas utilisées de manière négative.",
      "La prise de l’ours peut être autorisée, mais les mains jointes autour de l’adversaire peuvent être sanctionnées.",
      "Une fois le kumikata installé, le combattant dispose d’un temps limité pour lancer une attaque.",
      "Le seoi-nage inversé peut être autorisé selon la catégorie, avec restriction chez les cadets.",
    ],
  },
  {
    id: "actions-interdites",
    mode: "arbitrage",
    badge: "Sanctions",
    title: "Actions interdites et sanctions",
    image:
      "https://res.cloudinary.com/dy5kblr32/image/upload/v1720731412/images/arbitrage/arbitrage_judo_03_b1ibhn.jpg",
    rules: [
      {
        id: "shido",
        title: "Infractions légères : Shido",
        bullets: [
          "Éviter intentionnellement le kumikata.",
          "Adopter une attitude défensive exagérée.",
          "Effectuer une fausse attaque.",
          "Sortir volontairement de la surface de combat.",
          "Rompre la saisie adverse de manière interdite.",
          "Empêcher volontairement l’adversaire de prendre sa saisie.",
        ],
      },
      {
        id: "hansoku-grave",
        title: "Infractions graves : Hansoku-make",
        bullets: [
          "Toute action pouvant porter atteinte à l’intégrité physique de l’adversaire.",
          "Techniques illicites ou dangereuses.",
          "Actions contraires à l’esprit du judo.",
          "Insultes, gestes déplacés ou refus manifeste de respecter l’arbitre.",
          "Diving ou action dangereuse engageant la tête.",
        ],
      },
      {
        id: "succession-shido",
        title: "Succession des Shido",
        bullets: [
          "Trois shido entraînent Hansoku-make.",
          "Un combattant peut généralement reprendre la compétition après un Hansoku-make par cumul de shido.",
          "Un Hansoku-make direct pour action contraire à l’esprit du judo peut disqualifier de la compétition.",
        ],
      },
    ],
  },
  {
    id: "duree-combats",
    mode: "arbitrage",
    badge: "Temps",
    title: "Durée des combats",
    image:
      "https://res.cloudinary.com/dy5kblr32/image/upload/v1720760819/images/arbitrage/arbitrage_judo_07_mo5tqx.webp",
    rules: [
      {
        id: "temps-categories",
        title: "Temps de combat selon les catégories",
        bullets: [
          "Mini-poussins et poussins : 1 min 30.",
          "Benjamins : 2 min.",
          "Minimes, cadets, juniors, seniors 2D/3D : 3 min.",
          "Cadets 1D, juniors 1D, seniors 1D : 4 min.",
          "Temps de récupération : deux fois la durée du combat.",
        ],
      },
      {
        id: "golden-score",
        title: "Golden Score",
        paragraphs: [
          "Le Golden Score est une prolongation utilisée pour départager les combattants. Le premier judoka qui marque ou qui obtient l’avantage décisif remporte le combat.",
        ],
      },
    ],
  },
  {
    id: "role-cs",
    mode: "cs",
    badge: "Table",
    title: "Rôle du commissaire sportif",
    image:
      "https://res.cloudinary.com/dy5kblr32/image/upload/v1720732018/images/arbitrage/arbitrage_judo_05_yce4cw.webp",
    bullets: [
      "Suivi des combats.",
      "Enregistrement des scores.",
      "Gestion du temps des combats.",
      "Annonce des résultats.",
      "Gestion de la pesée.",
    ],
  },
  {
    id: "regles-cs",
    mode: "cs",
    badge: "Règlement CS",
    title: "Quelques règles utiles à la table",
    image:
      "https://res.cloudinary.com/dy5kblr32/image/upload/v1720757031/images/arbitrage/arbitrage_judo_06_h2yqp4.jpg",
    rules: [
      {
        id: "ceinture-rouge",
        title: "Ceinture rouge, kimono bleu ?",
        paragraphs: [
          "En France, le premier judoka appelé porte généralement la ceinture rouge. Contrairement à la FIJ, le premier appelé porte un kimono blanc et le second un kimono bleu.",
        ],
      },
      {
        id: "coaching",
        title: "Coaching",
        paragraphs: [
          "Des benjamins jusqu’aux seniors, le coaching se fait entre les Matte et les Hajime de l’arbitre.",
        ],
      },
      {
        id: "immobilisation-cs",
        title: "Temps d’immobilisation",
        bullets: [
          "Ippon : 20 secondes.",
          "Waza-ari : de 10 à 19 secondes.",
          "Kinza : moins de 10 secondes, pour certaines animations.",
        ],
      },
      {
        id: "notation-scores",
        title: "Notation des scores",
        paragraphs: [
          "La notation s’établit à deux chiffres, suivie du nombre de shido ou d’une lettre selon le cas.",
        ],
        bullets: [
          "Exemples : 10 / 00.",
          "10 / 01.3.",
          "01.1 / 00.2.",
          "02.2 / 01.",
        ],
      },
    ],
  },
  {
    id: "points-poule",
    mode: "cs",
    badge: "Classement",
    title: "Attribution des points en poule ou en équipe",
    image:
      "https://res.cloudinary.com/dy5kblr32/image/upload/v1720731797/images/arbitrage/arbitrage_judo_04_o2hiap.webp",
    bullets: [
      "Victoire par waza-ari : 1 point.",
      "Victoire par waza-ari awasete ippon : 10 points.",
      "Victoire par ippon : 10 points.",
      "Victoire par disqualification, forfait, abandon ou décision médicale : 10 points.",
      "Victoire par décision en animation : 0 point.",
    ],
  },
  {
    id: "classement-poule",
    mode: "cs",
    badge: "Poule",
    title: "Critères de classement en poule",
    image:
      "https://res.cloudinary.com/dy5kblr32/image/upload/v1720731412/images/arbitrage/arbitrage_judo_03_b1ibhn.jpg",
    bullets: [
      "Nombre de victoires individuelles.",
      "Nombre de points marqués.",
      "Comparaison directe si égalité parfaite entre deux judokas.",
      "Poule en avantage décisif si plus de deux judokas sont à égalité parfaite.",
    ],
  },
  {
    id: "table-marquage",
    mode: "cs",
    badge: "Organisation",
    title: "Table d’arbitrage et commissaires sportifs",
    image:
      "https://res.cloudinary.com/dy5kblr32/image/upload/v1720732018/images/arbitrage/arbitrage_judo_05_yce4cw.webp",
    rules: [
      {
        id: "enregistrement",
        title: "Enregistrement des scores et du temps",
        bullets: [
          "Les commissaires sportifs enregistrent les ippon, waza-ari et pénalités.",
          "Ils supervisent le chronomètre de combat et le chronomètre d’immobilisation.",
          "Ils assistent l’arbitre dans le suivi des décisions.",
          "Ils annoncent ou valident le résultat administratif du combat.",
        ],
      },
      {
        id: "importance-table",
        title: "Importance de la table de marquage",
        paragraphs: [
          "La table de marquage assure une gestion équitable et transparente des combats. Son rôle est essentiel pour garantir des résultats fiables et un bon déroulement de la compétition.",
        ],
      },
    ],
  },
  {
    id: "formation-arbitres",
    mode: "cs",
    badge: "Formation",
    title: "Formation des arbitres et commissaires sportifs",
    image:
      "https://res.cloudinary.com/dy5kblr32/image/upload/v1720731410/images/arbitrage/arbitrage_judo_02_rpacmx.jpg",
    bullets: [
      "Les écoles d’arbitrage départementales permettent de former les jeunes arbitres et commissaires sportifs.",
      "Les niveaux peuvent être départementaux, régionaux, nationaux ou internationaux.",
      "Le commissaire sportif est souvent une première étape dans la compréhension de l’arbitrage.",
    ],
  },
];

export const ARBITRAGE_QUIZ_QUESTIONS = [
  {
    id: "q-hajime",
    question: "Que signifie le terme Hajime en arbitrage de judo ?",
    options: ["Début du combat", "Arrêt temporaire", "Fin du combat"],
    correctAnswer: "Début du combat",
  },
  {
    id: "q-ippon-osaekomi",
    question: "Combien de temps une immobilisation doit durer pour un Ippon ?",
    options: ["10 secondes", "20 secondes", "15 secondes"],
    correctAnswer: "20 secondes",
  },
  {
    id: "q-matte",
    question: "Que signifie Matte ?",
    options: ["Arrêt temporaire du combat", "Début d’une immobilisation", "Fin du combat"],
    correctAnswer: "Arrêt temporaire du combat",
  },
  {
    id: "q-hansoku",
    question: "Qu’est-ce qu’un Hansoku-make ?",
    options: ["Un avantage léger", "Une disqualification", "Une pénalité mineure"],
    correctAnswer: "Une disqualification",
  },
  {
    id: "q-fausse-attaque",
    question: "Quelle est la pénalité pour une fausse attaque répétée ?",
    options: ["Shido", "Waza-ari", "Hansoku-make"],
    correctAnswer: "Shido",
  },
  {
    id: "q-sore-made",
    question: "Que signifie Sore-made en arbitrage de judo ?",
    options: ["Début du combat", "Fin du combat", "Pause du combat"],
    correctAnswer: "Fin du combat",
  },
  {
    id: "q-waza-ari-osaekomi",
    question: "Quelle durée d’immobilisation donne un Waza-ari ?",
    options: ["10 à 19 secondes", "20 secondes", "5 à 9 secondes"],
    correctAnswer: "10 à 19 secondes",
  },
  {
    id: "q-osaekomi",
    question: "Que signifie Osaekomi ?",
    options: ["Début d’une immobilisation", "Fin d’une immobilisation", "Arrêt temporaire"],
    correctAnswer: "Début d’une immobilisation",
  },
  {
    id: "q-3-shido",
    question: "Combien de Shido entraînent une disqualification ?",
    options: ["3 Shido", "2 Shido", "4 Shido"],
    correctAnswer: "3 Shido",
  },
  {
    id: "q-shido-geste",
    question: "Quel geste est utilisé pour signaler une pénalité Shido ?",
    options: ["Un bras tendu horizontalement", "Les deux bras croisés", "Pointer avec l’index tendu"],
    correctAnswer: "Pointer avec l’index tendu",
  },
  {
    id: "q-toketa",
    question: "Que signifie Toketa ?",
    options: ["Début d’une immobilisation", "Fin d’une immobilisation", "Arrêt temporaire"],
    correctAnswer: "Fin d’une immobilisation",
  },
  {
    id: "q-minimes",
    question: "Quelle est la durée d’un combat chez les Minimes ?",
    options: ["2 minutes", "3 minutes", "4 minutes"],
    correctAnswer: "3 minutes",
  },
  {
    id: "q-golden-score",
    question: "Que signifie Golden Score ?",
    options: ["Une pénalité décisive", "Prolongation jusqu’à un score", "Fin immédiate du combat"],
    correctAnswer: "Prolongation jusqu’à un score",
  },
  {
    id: "q-cs-role",
    question: "Quel est le rôle principal des commissaires sportifs ?",
    options: ["Attribuer les pénalités", "Enregistrer les points et le temps", "Demander le médecin"],
    correctAnswer: "Enregistrer les points et le temps",
  },
  {
    id: "q-benjamins",
    question: "Quelle est la durée d’un combat pour les Benjamins ?",
    options: ["1 minute 30", "2 minutes", "3 minutes"],
    correctAnswer: "2 minutes",
  },
  {
    id: "q-poussins",
    question: "Quelle est la durée d’un combat pour les Poussins ?",
    options: ["1 minute", "1 minute 30", "2 minutes"],
    correctAnswer: "1 minute 30",
  },
];

export function shuffleArray(items = []) {
  return [...items].sort(() => Math.random() - 0.5);
}

export function buildQuizQuestions(questions = [], count = 10) {
  const uniqueQuestions = Array.from(
    new Map(questions.map((question) => [question.id, question])).values(),
  );

  return shuffleArray(uniqueQuestions).slice(0, count);
}

export const ARBITRAGE_STATS = {
  sections: ARBITRAGE_SECTIONS.length,
  rules: ARBITRAGE_SECTIONS.reduce(
    (total, section) => total + (section.rules?.length || 0),
    0,
  ),
  quiz: ARBITRAGE_QUIZ_QUESTIONS.length,
};